import React from "react";
import { Link } from "react-router-dom";
import { Heart, CreditCard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { RESTRICTION_COPY, RESTRICTION_CTA } from "@/lib/trialCopy";

export function TrialBanner() {
  const { user } = useAuth();
  if (!user || !user.restricted) return null;
  const reason = user.restriction_reason || "trial_expired";
  const copy = RESTRICTION_COPY[reason] || RESTRICTION_COPY.trial_expired;
  const cta = RESTRICTION_CTA[reason] || RESTRICTION_CTA.trial_expired;

  return (
    <div
      className="border-b border-primary/20 bg-primary/5"
      data-testid="trial-banner"
    >
      <div className="mx-auto flex max-w-6xl flex-col items-start gap-3 px-6 py-3 sm:flex-row sm:items-center sm:justify-between lg:px-10">
        <div className="flex items-start gap-2.5">
          <Heart className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
          <p className="text-sm text-foreground">{copy}</p>
        </div>
        <Link to="/dashboard/billing" className="shrink-0">
          <Button size="sm" className="gap-2 font-semibold" data-testid="trial-banner-cta">
            <CreditCard className="h-4 w-4" />
            {cta}
          </Button>
        </Link>
      </div>
    </div>
  );
}
